/* eslint-disable new-cap */
import React from 'react'
import PropTypes from 'prop-types'

import styles from './style.module.scss'
import { dateCheck, dateMonth, MonthYear } from '@shared-submodule/utils'
import CustomLink from '../customLink'
import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'

const CurrentFutureSeriesList = ({ data }) => {
  return (
    <>
      {data?.length !== 0 && <div className={styles.archiveList}>
        {data?.map((seriesData, index) => {
          return (
            <div key={index} className={`${styles.item} common-box d-flex mb-2`}>
              <div className={`${styles.month} me-3 me-md-4 d-flex justify-content-center align-items-center font-semi flex-column flex-shrink-0 text-uppercase`}>
                <h4 className={`mb-0 ${styles.monthName}`}>{MonthYear(seriesData?.sMonth).substring(0, 3)}</h4>
                <p className="mb-0">{MonthYear(seriesData?.sMonth).substring(4, 8)}</p>
              </div>
              <div className={`${styles.series} flex-grow-1`}>
                {seriesData?.aSeries?.map((series) => {
                  return (
                    <React.Fragment key={series._id}>
                      <div className={`${styles.seriesItem} d-md-flex justify-content-md-between align-items-center`}>
                        <div className="font-semi mb-1 mb-md-0 flex-grow-1">
                          {series?.oCategory?.oSeo?.sSlug || series?.oSeo?.sSlug ? <CustomLink href={`/${series?.oCategory?.oSeo?.sSlug || series?.oSeo?.sSlug}`} prefetch={false}><a>{series?.sTitle}</a></CustomLink> : series?.sTitle}
                          <p className={`${styles.links} mb-0 mt-md-1 d-flex align-items-center`}>
                            {
                              series?.oSeo?.eType !== 'se' && <CustomLink href={allRoutes.seriesNews(`${series?.oCategory?.oSeo?.sSlug || series?.oSeo?.sSlug || ''}/`)} prefetch={false}><a className="d-flex align-items-center">{'News'}</a></CustomLink>
                            }
                            <CustomLink href={getFixturesLink(series)} prefetch={false}><a className="d-flex align-items-center">{'Fixtures'}</a></CustomLink>
                          </p>
                        </div>
                        <p className={`${styles.duration} flex-shrink-0 mb-0`}>
                          {dateMonth(dateCheck(series?.dStartDate))} - {dateMonth(dateCheck(series?.dEndDate))}
                        </p>
                      </div>
                    </React.Fragment>
                  )
                })}
              </div>
            </div>
          )
        })}
      </div>}
    </>
  )
}

CurrentFutureSeriesList.propTypes = {
  data: PropTypes.array
}

export default CurrentFutureSeriesList

function getFixturesLink(series) {
  const slug = series?.oCategory?.oSeo?.sSlug || series?.oSeo?.sSlug || ''
  return !series?.oCategory?.oSeo?.sSlug ? `/${slug}/` : allRoutes.seriesFixtures(`/${slug}/`)
}
